// extracted by mini-css-extract-plugin
export default {"form":"EditForm_form__r8+MM","oneliner":"EditForm_oneliner__MVVpd","fieldContainer":"EditForm_fieldContainer__AUO1V","buttons":"EditForm_buttons__thJqv"};